import { EventInfo, ListBoxComponentProps, ListComponentItemType, UserInfo } from "@/types"
import { CollectionItem, Input, Listbox, useFilter, useListCollection } from "@chakra-ui/react"

const ListBoxComponent = (props: ListBoxComponentProps) => {

    const onValueChange = props.onValueChange

    const { contains } = useFilter({ sensitivity: "base" })

    const { collection, filter } = useListCollection({
        initialItems: createItemList(props.itemList, props.itemListType),
        filter: contains,
    })

    console.log(collection.items)

    return (
        <>
        <Listbox.Root collection={collection} onValueChange={onValueChange} >
        <Listbox.Input
            as={Input}
            placeholder="Type to filter frameworks..."
            onChange={(e) => {console.log(e); filter(e.target.value)}}
        />
        <Listbox.Content>
            {collection.items.map((item: CollectionItem) => (
            <Listbox.Item item={item} key={item.value}>
                <Listbox.ItemText color="white">{item.label}</Listbox.ItemText>
                <Listbox.ItemIndicator />
            </Listbox.Item>
            ))}
        </Listbox.Content>
        <Listbox.Empty>Nothing here but us chickens!</Listbox.Empty>
        </Listbox.Root>
        </>
    )
}

const createItemList = (list: UserInfo[] | EventInfo[], listType: ListComponentItemType): CollectionItem[] => {
    const out: CollectionItem[] = []

    if ( listType == ListComponentItemType.UserInfo) {
        (list as UserInfo[]).map((itm: UserInfo) => {
            out.push({label: itm.name, value: itm.telegram_id})
        })
    } else {
        (list as EventInfo[]).map((itm: EventInfo) => {
            out.push({label: itm.name, value: itm.event_id})
        })
    }
    return out
}



export default ListBoxComponent
